import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import heroBackground from '../../assets/hero-background.jpg';

const Hero = () => {
  return (
    <div className="relative min-h-screen flex items-center">
      <div className="absolute inset-0 z-0">
        <img
          src={heroBackground}
          alt="Excavator on construction site"
          className="object-cover w-full h-full brightness-[0.85]"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-dark/30 via-transparent to-dark" />
      </div>
      
      <div className="container mx-auto px-4 z-10 pb-20 sm:pb-0">
        <div className="max-w-3xl">
          
          

          <div className="space-y-8 animate-slide-up">
            <h1 className="text-3xl sm:text-5xl md:text-7xl font-bold text-white mb-6 sm:mb-8 leading-tight drop-shadow-lg">
              Ihr Partner für <span className="text-[#B5E2BF] drop-shadow-lg">professionelle</span> Umwelttechnik
            </h1>
            <div className="w-20 h-1.5 bg-gradient-to-r from-success to-success/30 rounded-full" />
            <p className="text-lg sm:text-xl text-white mb-8 sm:mb-12 leading-relaxed drop-shadow">
              Inspektionsstelle, Ingenieurbüro und Unternehmensberatung <br className="hidden sm:block" /> 
              – zuverlässig, effizient und individuell für Unternehmen, <br className="hidden sm:block" />
              öffentliche Einrichtungen und Privatpersonen
            </p>
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-6">
              <Link
                to="/contact"
                className="group bg-success hover:bg-success/90 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-xl text-base sm:text-lg font-medium transition-all inline-flex items-center justify-center hover:translate-y-[-2px] hover:shadow-xl shadow-lg shadow-dark/20"
              >
                <span>Beratung anfordern</span>
                <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
              </Link>
              <Link
                to="/services"
                className="group bg-white hover:bg-white/90 text-dark px-6 sm:px-8 py-3 sm:py-4 rounded-xl text-base sm:text-lg font-medium transition-all inline-flex items-center justify-center hover:translate-y-[-2px] hover:shadow-xl shadow-lg"
              >
                <span>Unsere Leistungen</span>
                <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
              </Link>
            </div>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-dark to-transparent z-[5]" />
    </div>
  );
};

export default Hero;